import React, { useCallback } from "react";
import Icofont from "react-icofont";
import { CardBody, CardTitle } from "reactstrap";
import { useIntl } from "react-intl";
import { WebForm } from "../../../../cores/webForm/interfaces/api/get-web-form";
import { PanelWembii } from "../../PanelWembii";
import { TitleWembii } from "../../TitleWembii";

interface Props {
  onEdit: () => void;
  onDelete: () => void;
  onCopy: () => void;
  canCreate: boolean;
  webForm: WebForm;
}

export default function FormCard(props: Props) {
  const intl = useIntl();
  const { webForm, canCreate, onEdit, onDelete, onCopy } = props;

  const accent = webForm.titleColor || webForm.buttonColor || "#0b65c2";

  const stop = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
  }, []);

  return (
    <PanelWembii
      shadow
      key={webForm.id}
      className="web-form-card align-content-center d-flex justify-content-center p-3 pointer"
      onClick={onEdit}
    >
      <CardBody className="web-form-card-body p-2 d-flex flex-column justify-content-between w-100">
        <div style={{ minWidth: 0 }}>
          <div className="web-form-card-chip">
            <span
              className="web-form-card-chip-swatch"
              style={{ backgroundColor: accent }}
            />
          </div>
          <CardTitle className="mb-0">
            <TitleWembii
              Tag="h4"
              mb={false}
              className="overflow-hidden web-form-card-title"
            >
              {webForm.name}
            </TitleWembii>
          </CardTitle>
          {webForm.title && webForm.title.trim() !== webForm.name.trim() && (
            <p className="web-form-card-subtitle text-truncate mb-0 mt-1">
              {webForm.title}
            </p>
          )}
        </div>

        <div className="web-form-card-footer" onClick={stop}>
          <span className="web-form-card-hint">
            {intl.formatMessage({ id: "app.advertisements.formWebCardHint" })}
          </span>
          <div className="web-form-card-actions">
            <button
              type="button"
              className="web-form-card-action-btn"
              aria-label={intl.formatMessage({
                id: "app.advertisements.formWebEditAria",
              })}
              onClick={(e) => {
                stop(e);
                onEdit();
              }}
            >
              <Icofont icon="edit" />
            </button>
            {canCreate && (
              <button
                type="button"
                className="web-form-card-action-btn"
                aria-label={intl.formatMessage({
                  id: "app.advertisements.formWebCopyAria",
                })}
                onClick={(e) => {
                  stop(e);
                  onCopy();
                }}
              >
                <Icofont icon="copy" />
              </button>
            )}
            <button
              type="button"
              className="web-form-card-action-btn web-form-card-action-btn--danger"
              aria-label={intl.formatMessage({
                id: "app.advertisements.formWebDeleteAria",
              })}
              onClick={(e) => {
                stop(e);
                onDelete();
              }}
            >
              <Icofont icon="ui-delete" />
            </button>
          </div>
        </div>
      </CardBody>
    </PanelWembii>
  );
}
